import React from 'react';

const MarketPanelSectorRotation = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Sector Rotation</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="sector-rotation">
            <thead>
              <tr>
                <th>Sector</th>
                <th>Rotation Score</th>
                <th>Momentum</th>
                <th>Relative Strength</th>
                <th>Volume Trend</th>
                <th>Price Trend</th>
                <th>Market Cap (₹ Cr)</th>
                <th>P/E Ratio</th>
                <th>Dividend Yield</th>
                <th>Current Value</th>
                <th>% Change</th>
                <th>Outlook</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.sector || '-'}</td>
                    <td>{item.rotation_score || '-'}</td>
                    <td>{item.momentum || '-'}</td>
                    <td>{item.relative_strength || '-'}</td>
                    <td>{item.volume_trend || '-'}</td>
                    <td>{item.price_trend || '-'}</td>
                    <td>{item.market_cap || '-'}</td>
                    <td>{item.pe_ratio || '-'}</td>
                    <td>{item.dividend_yield || '-'}</td>
                    <td>{item.current_value || '-'}</td>
                    <td>{item.percent_change || '-'}</td>
                    <td>{item.outlook || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelSectorRotation; 